var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "savings"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2137_2116",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2137_2116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "savings_2",
    d: "M16 11.5C16.2833 11.5 16.5208 11.4042 16.7125 11.2125C16.9042 11.0208 17 10.7833 17 10.5C17 10.2167 16.9042 9.97917 16.7125 9.7875C16.5208 9.59583 16.2833 9.5 16 9.5C15.7167 9.5 15.4792 9.59583 15.2875 9.7875C15.0958 9.97917 15 10.2167 15 10.5C15 10.7833 15.0958 11.0208 15.2875 11.2125C15.4792 11.4042 15.7167 11.5 16 11.5ZM8 9.5H13V7.5H8V9.5ZM4.5 21.5C3.93333 19.6 3.375 17.7042 2.825 15.8125C2.275 13.9208 2 11.9833 2 10C2 8.46667 2.53333 7.16667 3.6 6.1C4.66667 5.03333 5.96667 4.5 7.5 4.5H12.5C12.9833 3.86667 13.5708 3.375 14.2625 3.025C14.9542 2.675 15.7 2.5 16.5 2.5C16.9167 2.5 17.2708 2.64583 17.5625 2.9375C17.8542 3.22917 18 3.58333 18 4C18 4.1 17.9875 4.2 17.9625 4.3C17.9375 4.4 17.9083 4.49167 17.875 4.575C17.8083 4.75833 17.7458 4.94583 17.6875 5.1375C17.6292 5.32917 17.5833 5.525 17.55 5.725L19.825 8H22V14.975L19.175 15.9L17.5 21.5H12V19.5H10V21.5H4.5ZM6 19.5H8V17.5H14V19.5H16L17.55 14.35L20 13.525V10H19L15.5 6.5C15.5 6.16667 15.5208 5.84583 15.5625 5.5375C15.6042 5.22917 15.6667 4.91667 15.75 4.6C15.2667 4.73333 14.8417 4.9625 14.475 5.2875C14.1083 5.6125 13.8417 6.01667 13.675 6.5H7.5C6.53333 6.5 5.70833 6.84167 5.025 7.525C4.34167 8.20833 4 9.03333 4 10C4 11.6333 4.225 13.2292 4.675 14.7875C5.125 16.3458 5.56667 17.9167 6 19.5Z",
    fill: "#4D2481"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavings);
export default __webpack_public_path__ + "static/media/savings.63d73ac467eebbbde9dd229477fbb870.svg";
export { ForwardRef as ReactComponent };